import React from 'react';
import FormField from '../FormField';
import SectionHeader from '../SectionHeader';

const StudentDetails = ({ formData, handleChange, errors, isVisible, toggleSection }) => {
  return (
    <div className="form-section">
      <SectionHeader 
        title="Student Details" 
        isVisible={isVisible} 
        onClick={toggleSection} 
      />
      
      {isVisible && (
        <div className="section-content">
          <FormField
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            error={errors.name}
            required={true}
          />
          
          <FormField
            label="Email ID"
            type="email"
            name="email_Id"
            value={formData.email_Id}
            onChange={handleChange}
            error={errors.email_Id}
            required={true}
          />
          
          <FormField
            label="Contact Number"
            name="contactNo"
            value={formData.contactNo}
            onChange={handleChange}
            error={errors.contactNo}
            required={true}
          />
          
          <FormField
            label="Date of Birth"
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleChange}
          />
          
          <FormField
            label="Address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            required={true}
          />
        </div>
      )}
    </div>
  );
};

export default StudentDetails;